(() => {
  const PATCHED_ATTRIBUTE = 'data-yuenuo-category-carousel-patched';

  function findCarousels() {
    return Array.from(document.querySelectorAll('[class^="ai-category-carousel-"][data-autoplay-speed]'))
      .filter((element) => element.tagName.startsWith('CATEGORY-CAROUSEL-'));
  }

  function getOriginalItemCount(items) {
    const indexes = items
      .map((item) => Number.parseInt(item.dataset.index, 10))
      .filter((index) => Number.isFinite(index));

    if (indexes.length === 0) {
      return items.length;
    }

    return Math.max(...indexes) + 1;
  }

  function getVisibleCount(root) {
    if (window.innerWidth < 750) {
      return 2;
    }

    if (window.innerWidth < 990) {
      return 2;
    }

    return Number.parseInt(root.dataset.itemsPerPage, 10) || 3;
  }

  function setupCarousel(root) {
    if (root.hasAttribute(PATCHED_ATTRIBUTE)) {
      return;
    }

    const track = root.querySelector('[class*="ai-category-carousel-track-"]');
    const previousButton = root.querySelector('[class*="ai-category-carousel-prev-"]');
    const nextButton = root.querySelector('[class*="ai-category-carousel-next-"]');

    if (!track || !previousButton || !nextButton) {
      return;
    }

    root.setAttribute(PATCHED_ATTRIBUTE, 'true');

    let currentIndex = 0;
    let touchStartX = 0;
    let touchStartY = 0;

    function getItems() {
      return Array.from(track.children).filter((child) => child.matches('[class*="ai-category-carousel-item-"]'));
    }

    function getMaxIndex() {
      const items = getItems();
      const originalItemCount = getOriginalItemCount(items);
      return Math.max(0, originalItemCount - getVisibleCount(root));
    }

    function getStepWidth() {
      const firstItem = getItems()[0];
      if (!firstItem) {
        return 0;
      }

      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      return firstItem.getBoundingClientRect().width + gap;
    }

    function setButtonsEnabled() {
      previousButton.disabled = false;
      nextButton.disabled = false;
      previousButton.removeAttribute('aria-disabled');
      nextButton.removeAttribute('aria-disabled');
    }

    function updatePosition() {
      const maxIndex = getMaxIndex();
      currentIndex = Math.min(Math.max(currentIndex, 0), maxIndex);
      const offset = currentIndex * getStepWidth();

      track.style.transition = 'transform 0.42s ease';
      track.style.transform = `translate3d(${-offset}px, 0, 0)`;
      setButtonsEnabled();
    }

    function moveBy(delta) {
      const maxIndex = getMaxIndex();
      currentIndex += delta;

      if (currentIndex < 0) {
        currentIndex = maxIndex;
      }

      if (currentIndex > maxIndex) {
        currentIndex = 0;
      }

      root.isPaused = true;
      updatePosition();
    }

    previousButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      moveBy(-1);
    }, true);

    nextButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      moveBy(1);
    }, true);

    track.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      if (!touch) {
        return;
      }

      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      root.isPaused = true;
    }, { passive: true });

    track.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      if (!touch) {
        return;
      }

      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;

      if (Math.abs(deltaX) < 36 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) {
        return;
      }

      if (deltaX < 0) {
        moveBy(1);
      } else {
        moveBy(-1);
      }
    }, { passive: true });

    window.addEventListener('resize', updatePosition);
    setButtonsEnabled();
    updatePosition();
  }

  function setupAllCarousels() {
    findCarousels().forEach(setupCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAllCarousels);
  } else {
    setupAllCarousels();
  }

  const observer = new MutationObserver(setupAllCarousels);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
